import React, { useEffect } from "react";
import { bool } from "prop-types";
import { goBack, push } from "connected-react-router";
import { useDispatch, useSelector } from "react-redux";
import { isEmpty } from "lodash";
import { ResponsiveHeader } from "pages/_components/header";
import { Field, Form, Formik } from "formik";
import MainContainer from "pages/_components/MainContainer";
import Notification from "pages/_components/Notification";
import FieldLabel from "pages/_components/fields/FieldLabel";
import Button from "pages/_components/Button";
import TextField from "pages/_components/fields/TextField";
import Loader from "pages/_components/Loader";
import { actions as notificationActions } from "reducers/notification";
import { actions as echeckActions, types } from "reducers/echecks";
import useSchema from "hooks/useSchema";
import * as i18n from "util/i18n";
import * as Yup from "yup";
import Beneficiaries from "../components/Beneficiaries";
import GridTable from "../../_components/GridTable/GridTable";

const FORM_ID = "echecks.cesion";

const EmitCesionPage = ({ isDesktop }) => {
    const dispatch = useDispatch();
    const { cesionEcheqData: cesionData, echeqsToDoActions: echeqAction } = useSelector((state) => state.echecks);
    const { stringRequired } = useSchema();
    const hasBeneficiary = cesionData?.beneficiary?.reference;

    useEffect(() => {
        if (isEmpty(echeqAction)) {
            dispatch(goBack());
        }
    }, []);

    const initialValues = {
        address: cesionData?.cesionData?.address || "",
        reference: cesionData?.cesionData?.reference || "",
        referencevalue: cesionData?.cesionData?.referencevalue || "",
    };

    const endorseEcheckValidation = Yup.object().shape({
        address: stringRequired,
    });

    const handleSubmit = (values) => {
        if (!cesionData?.beneficiary?.reference) {
            dispatch(
                notificationActions.showNotification(i18n.get("echecks.empty.beneficiary"), "error", [
                    "echecks/cesion",
                ]),
            );
        } else {
            dispatch(echeckActions.echeqCesionData(values));
            dispatch(push("/echecks/action/cesion/confirm"));
        }
    };

    if (isEmpty(echeqAction)) {
        return <Loader />;
    }

    const getTitle = () => {
        return echeqAction?.echeqList?.length > 1 ? "echeq.emit.cesion.multiple.echeq" : "echeq.emit.cesion.echeq";
    }

    return (
        <>
            <Notification scopeToShow="echecks/cesion" />
            <Notification scopeToShow="echecks/beneficary" />
            <ResponsiveHeader id={getTitle()} />
            <MainContainer showLoader={false}>
                <Formik
                    initialValues={initialValues}
                    onSubmit={handleSubmit}
                    validationSchema={endorseEcheckValidation}>
                    {({ values }) => (
                        <Form>
                            <GridTable className="form cesion-echeq-form">
                                <GridTable.Container columns={12} columnsTemplate="fixed">
                                    <GridTable.Data columnStart={2} columnWidth={10} flexDirection="column">
                                        <FieldLabel labelKey="echecks.emit.beneficiary" />
                                        <Beneficiaries
                                            isDesktop={isDesktop}
                                            idForm={FORM_ID}
                                            beneficiaryData={cesionData}
                                            actionType={types.CESION_ECHEQ_BENEFICIARY}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} columnWidth={5}>
                                        <Field
                                            component={TextField}
                                            idForm={FORM_ID}
                                            hidePlaceholder
                                            name="address"
                                            type="text"
                                            labelText="echecks.address"
                                            disabled={!hasBeneficiary}
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={7} columnWidth={5}>
                                        <Field
                                            component={TextField}
                                            labelText="echecks.emit.reference.label"
                                            name="reference"
                                            type="text"
                                            disabled={!hasBeneficiary}
                                            hidePlaceholder
                                        />
                                    </GridTable.Data>
                                    <GridTable.Data columnStart={2} columnWidth={5}>
                                        <Field
                                            component={TextField}
                                            labelText="echecks.emit.referencevalue.label"
                                            name="referencevalue"
                                            type="text"
                                            disabled={!hasBeneficiary}
                                            hidePlaceholder
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                            <GridTable>
                                <GridTable.Container columns={12} columnsTemplate="fixed" className="form-actions">
                                    <GridTable.Data columnStart={isDesktop ? 5 : 1} columnWidth={isDesktop ? 4 : 12}>
                                        <Button
                                            type="submit"
                                            className="btn-primary"
                                            label="global.continue"
                                            disabled={!hasBeneficiary || !values.address}
                                        />
                                    </GridTable.Data>
                                </GridTable.Container>
                            </GridTable>
                        </Form>
                    )}
                </Formik>
            </MainContainer>
        </>
    );
};

EmitCesionPage.propTypes = {
    isDesktop: bool.isRequired,
};

export default EmitCesionPage;
